'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	trucateSentence = require('../models/truncate-sentence'),
	ENTER = 13;
require('./show-progress-message');

require('./show-error');
mmWidgets.fn.fileTagsWidget = function (fileListModel) {
	return mmWidgets.each(this, function () {
		let shownFiles = [];
		const element = this.addClass('hidden').sectionHandlerWidget(),
			listContainer = element.find('[data-mm-role~="tag-list"]'),
			emptyListMessage = element.find('[data-mm-role~="empty-tag-list"]'),
			tagTemplates = {
				all: listContainer.find('[data-mm-template~="template-checked"]').remove(),
				some: listContainer.find('[data-mm-template~="template-some-checked"]').remove(),
				none: listContainer.find('[data-mm-template~="template-unchecked"]').remove()
			},
			filterInput = element.find('[name="tagFilter"]'),
			addTagButton = element.find('[data-mm-role~="addTag"]'),
			showList = () => {
				element.showProgressMessage('Loading tags, please wait...');
				listContainer.empty();
				emptyListMessage.addClass('hidden');
				const filter = filterInput.val().trim(),
					tags = fileListModel.tagsForFiles(shownFiles),
					tagNames = Object.keys(tags).sort(),
					disabledTags = [];

				tagNames.forEach(tag => {
					const tagState = tags[tag],
						template = tagTemplates[tagState] || tagTemplates.none,
						row = template.clone();
					row.find('[data-mm-role~="tag"]').text(tag);
					if (filter && tag.indexOf(filter) === -1) {
						row.addClass('disabled');
						disabledTags.push(row);
						return;
					}
					row.click(() => {
						if (tags[tag] === 'all') {
							element.trigger(mmWidgets.Event('removeTag', {tag: tag}));
						} else {
							element.trigger(mmWidgets.Event('addTag', {tag: tag}));
						}
					});
					row.appendTo(listContainer);
					// listContainer.append(row);
				});
				disabledTags.forEach(row => row.appendTo(listContainer) /*listContainer.append(row)*/);
				if (!listContainer.children().length) {
					emptyListMessage.removeClass('hidden');
				}

				if (filter && !tagNames.includes(filter)) {
					addTagButton.removeClass('disabled');
				} else {
					addTagButton.addClass('disabled');
				}
				element.showSection('tag-list');
			},
			addTag = (newTag) => {
				element.showProgressMessage('Adding tag, please wait...');
				return fileListModel.addTagForFiles(newTag, shownFiles)
				.then(showList)
				.catch(reason => element.showError(reason));
			},
			removeTag = (oldTag) => {
				element.showProgressMessage('Removing tag, please wait...');
				fileListModel.removeTagForFiles(oldTag, shownFiles)
				.then(showList)
				.catch(reason => element.showError(reason));
			},
			insertTag = () => {
				if (addTagButton.hasClass('disabled')) {
					return;
				}
				const newTag = filterInput.val().trim();
				if (!newTag) {
					return;
				}
				addTag(newTag);
			};
		element.on('removeTag', (event) => removeTag(event.tag));
		element.on('addTag', (event) => addTag(event.tag));
		Object.keys(tagTemplates).forEach(key => {
			tagTemplates[key].removeProp('data-mm-template');
		});
		filterInput.on('keyup', showList);
		filterInput.on('keydown', function (e) {
			if (e.keyCode === ENTER && filterInput.isTarget(e)) {
				insertTag();
			}
		});
		element.on('show', () => {
			element.showProgressMessage('Loading, please wait...');
			filterInput.val('');
			fileListModel.ensureReady()
			.then(() => {
				const titleElement = element.find('[data-mm-role~="file-description"]');
				shownFiles = fileListModel.getActivatedFiles();

				if (!shownFiles || !shownFiles.length) {
					element.showError('no-selected-file');
					return;
				}
				if (shownFiles.length === 1) {
					titleElement.text(trucateSentence(shownFiles[0].description, 35));
				} else {
					titleElement.text('Multiple maps selected');
				}
				return true;
			})
			.then(shouldShowList => {
				if (shouldShowList) {
					showList();
				}
			})
			.then(() => element.trigger('showList-complete'));
		});
		element.on('hide', () => {
			shownFiles = [];
			fileListModel.toggleContextMenuForFile();
		});
		addTagButton.click(insertTag);
	});
};
